if ($('.type-detail').length) {
    var cacheTime = new Date().getMinutes();
    $.ajax({
        type: "GET",
        url: "/user/documents/products.json?v=" + cacheTime, // Předpokládáme, že máte JSON soubor
        dataType: "json", // Změna na JSON
        success: function (data) {
            if (sessionStorage.friendsProduct) {
                console.log("V session storage již existují všechna data, takže žádná nová data nebyla přidána.");
                // mhfriends();
            } else {
                console.log(data);
                sessionStorage.setItem('friendsProduct', JSON.stringify(data));
                console.log("Nová data byla úspěšně přidána do session storage.");
                mhfriends();
            }
        },
        error: function (error) {
            console.error("Chyba při načítání JSON dat: " + error.statusText);
        }
    });

    $(document).ready(function() {
        mhfriends();
    });

    function mhfriends() {
        if ($('.extended-description tr th:contains("Přátelské produkty")').length > 0) {
            
            $('.extended-description tr th:contains("Přátelské produkty")').closest('tr').hide();
            var getFriends = $('.extended-description tr th:contains("Přátelské produkty")').closest('tr').find('td').text().trim();
            const friendsProductCompressed = sessionStorage.getItem('friendsProduct');
            if (friendsProductCompressed) {
                // Dekompresování dat
                var friendsProduct = JSON.parse(friendsProductCompressed);
                var matchingProducts = friendsProduct.filter(function(product) {
                    return product.PAIRCODE === getFriends;
                });

                if (matchingProducts.length > 1) {
                    if ($('.friends').length < 1) {
                        $('.p-info-grid').before('<div class="friends"><p>Varianta</p><div class="friendsInner"></div></div>');
                    }
                    matchingProducts.forEach(function(product) {
                        if ($('.friends .friendsInner .product[data-custom-class="' + product.ORIG_URL.replace(/\//g, '').split('?variantId')[0] + '"]').length < 1) {
                            $('.friends .friendsInner').append('<div class="product" data-custom-class="' + product.ORIG_URL.replace(/\//g, '').split('?variantId')[0] + '"><span class="show-tooltip" title="' + product.NAME + '" data-original-title="' + product.NAME + '"><a href="/' + product.ORIG_URL.replace(/\//g, '').split('?variantId')[0] + '/"></a><div class="image"><img src="' + product.IMAGE + '" alt="' + product.NAME + '"></div></span></div>');
                        }
                    });
                    initTooltips();
                } else {
                    console.log("PAIRCODE má méně než dva produkty.");
                }
            } else {
                console.log("Data not found in sessionStorage.");
            }
            $('.friendsInner a').each(function() {
                if (document.location.pathname === $(this).attr('href')) {
                    $(this).closest('.product').addClass('active');
                }
            });
        }
    }
}